import Vue from 'vue'

const ENABLE  = 'ENABLE'
const DISABLE = 'DISABLE'

const state = {
  isActive: false,
}

export const mutations = {
  [ENABLE] (state) {
    state.isActive = true
  },
  [DISABLE] (state) {
    state.isActive = false
  }
}

export const actions = {
  enable({ commit }) {
    commit(ENABLE)
  },

  disable({ commit }) {
    commit(DISABLE)
  }
}

export const getters = {
  isActive: state => state.isActive
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/common/noData.js